module.exports = __webpack_public_path__ + "assets/04ce17483cd7c909d096133f3bea84b4.mp3";